import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import NavBar from "../components/Nav";
import Footer from "../components/footer";
import ScrollTop from "../components/Scrolltop";
import Whatsapp from "../components/Whatsapp";

import "./Contactus.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phone_number } = formData;
    if (!name || !email || !phone_number) {
      toast.warn("Please fill in all required fields.");
      return;
    }

    try {
      const response = await axios.post(
        "https://api.litaxfilers.com/contactusformdata",
        formData
      );
      toast.success(response.data.message);
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        phone_number: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting contact form:", error);
      toast.error("Error submitting contact form. Please try again.");
    }
  };

  return (
    <div>
      <NavBar />

      <div className="cform-wrapper">
        {/* Left: Form */}
        <div className="cform-left">
          <h2 className="cform-title">Get in Touch</h2>
          {submitted ? (
            <div className="cform-thankyou">
              <h3>Thank you for contacting us!</h3>
              <p>We will get back to you shortly.</p>
            </div>
          ) : (
            <form className="cform-form" onSubmit={handleSubmit}>
              <CFormInput
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <CFormInput
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <CFormInput
                label="Phone Number"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                required
              />
              <CFormInput
                label="Subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
              <CFormTextarea
                label="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={5}
              />

              <button type="submit" className="cform-btn">
                Submit
              </button>
            </form>
          )}
        </div>

        {/* Right: Info */}
      <div className="cform-right">
  <h2 className="cform-title">Contact Information</h2>
  <div className="cform-info">
    <p><strong>Address:</strong> 81 Thorn Lane, Newark, DE 19711</p>
    <p><strong>Email:</strong> info@litaxfilers.com</p>
    <p>
      <strong>Phone:</strong> 
      <span className="phone-number"> +1 (302) 390-8271</span>
    </p>
    <p><strong>Office Hours:</strong> Mon - Fri, 10:00 AM - 6:00 PM</p>
  </div>
  <div className="cform-map">
    <iframe
      title="office-map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.134284685721!2d-75.71792268462416!3d39.739069979451!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c77a5c5b1b5b5b%3A0x5c5c5c5c5c5c5c5c!2s81%20Thorn%20Ln%2C%20Newark%2C%20DE%2019711!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
      width="100%"
      height="250"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
    ></iframe>
  </div>
</div>
      </div>

      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

const CFormInput = ({ label, name, value, onChange, type = "text", required }) => (
  <div className="cform-field">
    <label htmlFor={name}>{label}</label>
    <input type={type} id={name} name={name} value={value} onChange={onChange} required={required} />
  </div>
);

const CFormTextarea = ({ label, name, value, onChange, rows = 4, required }) => (
  <div className="cform-field">
    <label htmlFor={name}>{label}</label>
    <textarea id={name} name={name} value={value} onChange={onChange} rows={rows} required={required}></textarea>
  </div>
);

export default ContactUs;
